"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Dock = _interopRequireDefault(require("@mui/icons-material/Dock"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsFetch = require("../../DmsFetch/DmsFetch");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsButtonStation = _ref => {
  let {
    row,
    handleShowStationModal
  } = _ref;
  const [hasStation, setHasStation] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const fetchStations = async () => {
      try {
        const response = await (0, _DmsFetch.fetchData)("/production_order_station/get_all_station/".concat(row.pk), "GET", true);
        const data = await response.data.data;
        if (data.rows.length > 0) {
          setHasStation(true);
        }
      } catch (error) {
        console.error("Error in found station: ", error);
      }
    };
    fetchStations();
  }, [row.pk]);
  return /*#__PURE__*/_react.default.createElement(_material.Chip, {
    label: _reactIntlUniversal.default.get("Station").d("Station"),
    onClick: () => handleShowStationModal(row),
    icon: /*#__PURE__*/_react.default.createElement(_Dock.default, {
      sx: {
        color: "#FFFFFF !important"
      }
    }),
    sx: {
      minWidth: "8vw",
      color: "#FFFFFF",
      backgroundColor: hasStation ? "#008B8B" : "red",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "1vw",
      ":hover": {
        backgroundColor: hasStation ? "#20B2AA" : "darkred"
      }
    }
  });
};
var _default = exports.default = DmsButtonStation;